import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../Loading-Component/Loading';

const GuidLanding = () => {
    const { coVal, userVal } = useParams();
    const { authenticateByGuid } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const authenticate = async () => {
            try {
                await authenticateByGuid(coVal, userVal);
                if (!cancelled) {
                    navigate('/report', { replace: true });
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err.message || 'This link has expired or is invalid. Please request a new one.');
                    setLoading(false);
                }
            }
        };

        authenticate();
        return () => { cancelled = true; };
    }, [coVal, userVal, authenticateByGuid, navigate]);

    if (error) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center px-4">
                <h2 className="mb-3">Authentication Failed</h2>
                <p className="text-muted mb-4">{error}</p>
                <a href="/login" className="btn btn-primary">
                    Go to Login
                </a>
            </div>
        );
    }

    return <LoadingSpinner loading={loading} />;
};

export default GuidLanding;
